module.exports = __webpack_public_path__ + "img/home_tp_s_icon.882c2e2.png";